import FormField from "./form-field";
import EventEmitter from "../event-emitter";

export default class FieldGroup extends EventEmitter {
	constructor(fields, options = {}) {
		super(options);

		this.fields = fields;
		this.options = options;

		this.FORCE_FORM_VALIDATION_EVENT = 'forceFormValidation';

		this.initialChecks();
	}

	initialChecks() {
		if (this.fields == null) {
			throw new Error('FieldGroup: fields prop is undefined');
		}

		if (typeof this.fields !== 'object') {
			throw new TypeError('FieldGroup: fields prop must be object');
		}

		const keys = Object.keys(this.fields);
		keys.forEach((key) => {
			const field = this.fields[key];

			if (!(field instanceof FormField)) {
				throw new Error('FieldGroup: field must be an instance of FormField');
			}
		});
	}

	init() {
		super.init();
	}

	forceFormValidation() {
		this.dispatchEvent(this.FORCE_FORM_VALIDATION_EVENT);
	}
}